import { BaseFunction } from '../types/base-function.type';
import { Action } from '../types/action.type';

export class LazyResolver<I, O> implements Action<I, O> {
  constructor(private readonly resolver: BaseFunction<I, Action<I, O>>) {}

  execute(input: I): O {
    const action = this.resolver(input);
    return action.execute(input);
  }
}
